export const INITIAL_PAGE_SIZE = 80;
export const CHILDREN_PAGE_SIZE = 100; // INITIAL_PAGE_SIZE was previously 160 but we reduced it to 80. Should we also reduce this?
